import React from 'react';
import { Link } from 'react-router-dom';
import { site } from '../data/site';

const Footer: React.FC = () => (
  <footer className="site-footer py-5">
    <div className="container text-center">
      <img
        src="/assets/logos/art-on-the-lake-mark.png"
        alt=""
        aria-hidden="true"
        width={72}
        height={72}
        className="mb-3"
      />
      <div className="footer-nav mb-3">
        <Link to="/" className="mx-2">Home</Link>
        <Link to="/about" className="mx-2">About</Link>
        <Link to="/festival" className="mx-2">Festival</Link>
        <Link to="/gallery" className="mx-2">Gallery</Link>
        <Link to="/sponsors" className="mx-2">Sponsors</Link>
        <Link to="/donate" className="mx-2">Donate</Link>
        <Link to="/contact" className="mx-2">Contact</Link>
      </div>

      <p className="mb-1">
        <a href={`mailto:${site.email}`}>{site.email}</a>
        <span className="mx-2" aria-hidden="true">·</span>
        <a href={site.phoneHref}>{site.phone}</a>
      </p>
      <p className="mb-3">
        <a href={site.facebook} target="_blank" rel="noopener noreferrer">
          Find us on Facebook
        </a>
      </p>

      <p className="mb-0 small">
        &copy; {new Date().getFullYear()} {site.name}. {site.location}.
      </p>
      <p className="mb-0 small">
        <Link to="/privacy" className="mx-2">Privacy Policy</Link>
        <Link to="/terms" className="mx-2">Terms of Use</Link>
      </p>
    </div>
  </footer>
);

export default Footer;
